import { Fragment } from "react"
import { Tab } from "@headlessui/react"
import { UserCircleIcon } from "@heroicons/react/24/solid"
import { PersonalInformation, ChangePassword, DeleteAccount, MyOrders, Upload } from './index'

export default function Profile({ user }){

    return(
        <div className="relative isolate overflow-hidden bg-white px-2 py-24 sm:py-28 lg:overflow-visible lg:px-7">
            <div className="grid grid-cols-2 px-2 sm:px-2 pt-2 sm:grid-cols-3 sm:gap-4">
                <Tab.Group>
                    <div className="col-span-full sm:col-auto">
                        <div className="p-4 mb-2 bg-white rounded-lg  lg:col-span-2 sm:p-4 shadow">
                            <div className="">
                                <div className="flex justify-center items-end"> 

                                    {/* <img src='' alt="user" className="mb-4 rounded-full w-52 h-52 sm:mb-0 lg:mb-4 xl:mb-0"/> */}
                                
                                    <UserCircleIcon className="w-52 h-52 text-gray-500 "/>
                                    <div className="absolute">
                                        <Upload/>
                                    </div>
                                </div> 
                                <div className="px-5">
                                    <div className="space-y-1 mt-2 text-center">
                                        <h2 className="text-black font-semibold text-xl">Rosy Kaduku</h2>
                                        <p className="text-gray-700 text-sm">rosykaduku4@gmail.com</p>
                                    </div>
                                </div>
                            </div>
                            <div className="px-3 py-8">
                                <Tab.List className='space-y-2'>
                                    <Tab as={Fragment} className="group relative flex gap-x-6 rounded-lg p-2 px-2 hover:bg-black hover:text-white">
                                    {({ selected }) => (
                                        <button
                                        className={
                                            selected ? 'w-full bg-black text-white font-semibold ' : 'w-full bg-white text-gray-900'
                                        }
                                        >
                                        Informations personnelles
                                        </button>
                                    )}
                                    </Tab>
                                    <Tab as={Fragment} className="group relative flex gap-x-6 rounded-lg p-2 px-2 hover:bg-black hover:text-white">
                                    {({ selected }) => (
                                        <button
                                        className={
                                            selected ? 'w-full bg-black text-white font-semibold ' : 'w-full bg-white text-gray-900'
                                        }
                                        >
                                        Mes commandes
                                        </button>
                                    )}
                                    </Tab>
                                    <Tab as={Fragment} className="group relative flex gap-x-6 rounded-lg p-2 px-2 hover:bg-black hover:text-white">
                                    {({ selected }) => (
                                        <button
                                        className={
                                            selected ? 'w-full bg-black text-white font-semibold' : 'w-full bg-white text-gray-900'
                                        }
                                        >
                                        Change le mot de passe
                                        </button>
                                    )}
                                    </Tab>
                                    <Tab as={Fragment} className="group relative flex gap-x-6 rounded-lg p-2 px-2 hover:bg-black hover:text-white">
                                    {({ selected }) => (
                                        <button
                                        className={
                                            selected ? 'w-full bg-black text-white font-semibold' : 'w-full bg-white text-gray-900'
                                        }
                                        >
                                        Supprimer le compte
                                        </button>
                                    )}
                                    </Tab>
                                </Tab.List>
                            </div>
                        </div>
                        
                        {/* <div className="p-4 mb-2 bg-white  rounded-lg 2xl:col-span-2 ">
                            <div className="flow-root">
                                
                            </div>
                        </div> */}
                    </div>
            
                    <div className="col-span-2">
                        <div className="p-4 mb-2 bg-white rounded-lg 2xl:col-span-2  shadow">
                            <Tab.Panels>
                                <Tab.Panel>
                                    <PersonalInformation />
                                </Tab.Panel>
                                <Tab.Panel>
                                    <MyOrders />
                                </Tab.Panel>
                                <Tab.Panel>
                                        <ChangePassword/>
                                </Tab.Panel>
                                <Tab.Panel>
                                        <DeleteAccount/>
                                </Tab.Panel>
                            </Tab.Panels>
                        </div>
                    </div>
                </Tab.Group>
            </div>
        </div>
    )
}